import { render, staticRenderFns } from "./NotificationTabsParts.vue?vue&type=template&id=7d01723c&scoped=true"
import script from "./NotificationTabsParts.vue?vue&type=script&lang=ts"
export * from "./NotificationTabsParts.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTabsParts.vue?vue&type=style&index=0&id=7d01723c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d01723c",
  null
  
)

export default component.exports